module.exports = __webpack_public_path__ + "media/4-star-wish-reveal.448bdab1.mp3";